import { GridusException } from './gridusException';

export class LimitDataNotValidateException extends GridusException {
  constructor(message: string = 'limit data not validate exception') {
    super(message, 'V0001', 'error');
  }
}
